import type { AccountEntitlement, EcosystemApp } from '../lib/api'

interface EcosystemAppsGridProps {
  apps: EcosystemApp[]
  isLoading: boolean
  entitlements?: AccountEntitlement[]
}

export function EcosystemAppsGrid({ apps, isLoading, entitlements = [] }: EcosystemAppsGridProps) {
  if (isLoading) {
    return <p className="hub-apps-status">Cargando apps del ecosistema…</p>
  }

  if (apps.length === 0) {
    return null
  }

  return (
    <div className="hub-apps-grid">
      {apps.map((app, index) => {
        const appEntitlements = entitlements.filter((e) => e.product === app.id)

        return (
          <a key={app.id} href={app.url} className="hub-app-card">
            <span className={`hub-app-card__icon${index % 2 === 1 ? ' hub-app-card__icon--accent' : ''}`}>
              {app.name.charAt(0).toUpperCase()}
            </span>
            <span className="hub-app-card__name">{app.name}</span>
            <span className="hub-app-card__description">{app.description}</span>
            {appEntitlements.length > 0 && (
              <span className="account-card__entitlements">
                {appEntitlements.map((e) => (
                  <span key={e.id} className="account-badge">
                    {e.scope}
                  </span>
                ))}
              </span>
            )}
          </a>
        )
      })}
    </div>
  )
}
